import { listIssueLabelsTool } from './list_issue_labels.js';

export const labelTools = [listIssueLabelsTool];
